import { useCallback } from "react";
import Toast from "./Toast";
import { useUI } from "../../context/UIContext";

const ToastHost = () => {
  const { toast, setToast } = useUI();
  const handleClose = useCallback(() => setToast(null), [setToast]);

  return (
    <Toast
      open={!!toast}
      message={toast?.message}
      duration={toast?.duration ?? 3000}
      severity={toast?.severity ?? "success"}
      onClose={handleClose}
      key={toast?.id}
    />
  );
};

export default ToastHost;
